<div class="btn-intro">
    <span></span>
    Scroll
</div>